import {
  AssessmentOutlined,
  Dashboard,
  DashboardOutlined,
  FolderOutlined,
  GavelOutlined,
  HelpCenterOutlined,
  InsertDriveFileOutlined,
  ManageAccountsOutlined,
  PeopleAltOutlined,
  SettingsOutlined,
  SummarizeOutlined,
} from "@mui/icons-material";
import ApprovalRoundedIcon from "@mui/icons-material/ApprovalRounded";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import GavelIcon from "@mui/icons-material/Gavel";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { type ReactNode } from "react";

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  items?: MenuItem[];
  name: string;
  roles?: any;
}
export interface GaItems {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
}
export interface GaMenuItems {
  items: GaItems[];
}

export const menuItems: MenuItems[] = [
  {
    items: [
      {
        name: "Dashboard",
        link: "/",
        icon: DashboardOutlined,
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "Users",
        link: "/vendor/users",
        icon: PeopleAltOutlined,
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "Proposals",
        link: "/vendor/proposal-list",
        icon: SummarizeOutlined,
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "Templates Bank",
        link: "/vendor/templates-bank-list",
        icon: FolderOutlined,
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "Analytics",
        link: "/vendor/analytics",
        icon: AssessmentOutlined,
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "Help Centre",
        link: "/vendor/help-center",
        icon: HelpCenterOutlined,
        roles: ["vendor_user", "vendor_admin"],
      },
    ].filter((item) => item !== null),
  },
];

export const tcsCorporateMenuItems: MenuItems[] = [
  {
    items: [
      {
        name: "Dashboard",
        link: "/",
        icon: Dashboard,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Users",
        link: "/corporate/users",
        icon: PeopleAltOutlined,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Analytics",
        link: "/corporate/analytics",
        icon: AssessmentOutlined,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Services Review",
        link: "/corporate/services-review",
        icon: SettingsOutlined,
        roles: ["system_admin", "t_user"],
      },
      {
        name: "Draft New Capacity Request",
        link: "/corporate/cr/create/description",
        icon: InsertDriveFileOutlined,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Templates Bank",
        link: "/corporate/templates-bank-list",
        icon: FolderOutlined,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Capacity Requests Repository",
        link: "/corporate/crs-list",
        icon: PlaylistAddCheckOutlinedIcon,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Preferred/Panel Vendors",
        link: "/corporate/preferred-vendors",
        icon: GavelOutlined,
        roles: ["system_admin", "t_user", "t_approver"],
      },
      {
        name: "Vendor Management",
        link: "/corporate/vendor-management",
        icon: ManageAccountsOutlined,
        roles: ["system_admin"],
      },
      {
        name: "T. Approver",
        link: "/corporate/t-approver",
        icon: ApprovalRoundedIcon,
        roles: ["t_approver"],
      },
      {
        name: "Help Centre",
        link: "/corporate/help-center",
        icon: HelpCenterOutlined,
        roles: ["system_admin", "t_user", "t_approver"],
      },
    ],
  },
];

export const gaMenuModel: GaMenuItems[] = [
  {
    items: [
      {
        name: "Dashboard",
        link: "/",
        icon: HomeOutlinedIcon,
      },

      {
        name: "corporate",
        link: "admin/coming-soon",
        icon: DomainAddIcon,
      },
      {
        name: "Vendor Providers",
        link: "admin/coming-soon",
        icon: GavelIcon,
      },
      {
        name: "Payments",
        link: "admin/coming-soon",
        icon: MonetizationOnIcon,
      },
      {
        name: "RFPs Repository",
        link: "admin/coming-soon",
        icon: HowToRegIcon,
      },
    ],
  },
];
